// File: src/components/solution/VideoShowcase.js

import React, { useRef, useState } from 'react';
import styles from './VideoShowcase.module.css';
import { cn } from '../../utils/helpers';
import { ASSETS_BASE_URL } from '../../config/constants';

const VIDEO_URL = `${ASSETS_BASE_URL}/head-of-a-lettuce-story.mp4`;

function VideoShowcase() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => setIsPlaying(true);
  const handlePause = () => setIsPlaying(false);
  const handleEnded = () => setIsPlaying(false);

  return (
    <section className={styles.section}>
      <div className={styles.card}>

        <video
          ref={videoRef}
          className={styles.video}
          controls
          playsInline
          preload="metadata"
          onPlay={handlePlay}
          onPause={handlePause}
          onEnded={handleEnded}
          aria-label="GreenScience waste transformation process"
        >
          <source src={VIDEO_URL} type="video/mp4" />
        </video>

        {/* Overlay fades out when playing */}
        <div className={cn(styles.overlay, isPlaying && styles.overlayHidden)}>
          <p className={styles.eyebrow}>See It In Action</p>
          <h1 className={styles.heading}>
            From Organic Waste to Valuable Resources
          </h1>
        </div>

      </div>

      <p className={styles.caption}>
        Our patented process transforms organic waste into valuable resources —
        reducing landfill waste and greenhouse gas emissions.
      </p>
    </section>
  );
}

export default VideoShowcase;